export default class Game {
    constructor(id, date, quizId, correctAnswers) {
        this.id = id;
        this.date = date;
        this.quizId = quizId;
        this.correctAnswers = correctAnswers;
    }
}